export const ExternalFacData = {
    id: '62e0afb3fcc7040d40737c9b',
    category_id: '62e0af0efcc7040d40737c90',
}